module.exports = __webpack_public_path__ + "static/media/tsukasa-aoi.f0f147b5.jpg";